export default __webpack_public_path__ + "static/924-f3ba886ab70c1288588d47570bc1135b.gif";